import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";

import SimpleSelect from "../simpleSelect";
import VirtualModuleTable from "../VirtualModuleTable";

export default function manyGenerateVirtualModuleChangeBlock(props) {
  const isDiffStyle = (enable, style) => {
    if (enable) return style + " bg-success";
    else return style;
  };

  return (
    <Row
      xs="12"
      className={isDiffStyle(props.enable, "w-100 mx-0 px-0")}
    >
      <Col
        xs="2"
        className="d-flex justify-content-center"
      >
        <Form.Check
          type="switch"
          id="dt_cb"
          className="align-self-center"
          checked={props.enable}
          onChange={(e) => props.onEnableChange(e.target.checked, props.name, props.type)}
        />
      </Col>
      <Col xs="10"   className="d-flex justify-content-center">
        <div
         className="align-self-center m-1"
          style={{ width: "90%", backgroundColor: "white", margin: "auto",height: "auto"}}
        >
          
                    <VirtualModuleTable
                      vm={props.value}
                      files={props.files}
                      onChange={props.onChange}
                      onEnableChange={props.onVirtualModuleEnableChange}
                    />
    
        </div>
      </Col>
    </Row>
  );
}
